angular.module('gym.contacts').controller('SharePaymentDetailsCtrl', ["$scope", "$rootScope", "$http", "$modalInstance", "$filter", "Contacts", "contact", "relationships", function($scope, $rootScope, $http, $modalInstance, $filter, Contacts, contact, relationships) {
  var gym, paymentSystem;
  $scope.gym = gym = $rootScope.gym;
  $scope.contact = contact;
  $scope.relationships = relationships;
  $scope.pageParams = {
    selectedContact: [],
    newRelationshipType: contact.relationship_types[0]
  };
  paymentSystem = $scope.gym.payment_system;
  $scope.getContacts = function(search) {
    $scope.isLoading = true;
    return Contacts.all('with_payment_methods').getList({
      search: search
    }).then(function(contacts) {
      $scope.isLoading = false;
      return _.reject(contacts, function(contact) {
        return _.find(relationships, function(relationship) {
          return contact.id === relationship.related_contact_id;
        });
      });
    });
  };
  $scope.selectRelationship = function(relationship) {
    $scope.removeContact();
    return $scope.pageParams.related_contact_id = relationship.related_contact_id;
  };
  $scope.addContact = function(selectedContact) {
    angular.element('.tags-input .input').blur();
    $scope.pageParams.related_contact_id = selectedContact.id;
    return $scope.pageParams.selectedContact = [selectedContact];
  };
  $scope.removeContact = function() {
    $scope.pageParams.addFamilyRelationship = false;
    return $scope.pageParams.selectedContact = [];
  };
  $scope.getPaymentMethod = function(relationship) {
    var ref;
    return ((ref = relationship.payment_method.data) != null ? ref.attributes : void 0) || relationship.payment_method;
  };
  $scope.isFormValid = function() {
    return $scope.pageParams.related_contact_id;
  };
  $scope.save = function() {
    var params, queryParams, url;
    url = `/gyms/${gym.id}/${contact.type}s/${contact.id}/${paymentSystem}/link_contact`;
    params = $scope.pageParams;
    queryParams = {
      related_contact_id: params.related_contact_id,
      relationship_type: params.addFamilyRelationship && params.newRelationshipType
    };
    $scope.isLoading = true;
    return $http.post(url, queryParams).then(function(response) {
      $scope.isLoading = false;
      $scope.$emit('contact:paymentMethod:updated');
      return $modalInstance.close();
    });
  };
  return $scope.cancel = function() {
    return $modalInstance.dismiss();
  };
}]);
